import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './lib/firebase';
import GetUser from './Authentication/GetUser';
import GetDash from './Authentication/GetDash';
import Sidebar from './Navigation/Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Loading from './loader/Loader';

function App() {
  // State to manage the authenticated user
  const [user, setUser] = useState(null);
  // State to manage loading state
  const [loading, setLoading] = useState(true);
  // State to manage sidebar visibility
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    // Subscribe to Firebase auth state changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      // Set user state based on auth state
      setUser(currentUser); 
      // Set loading to false once auth state is determined
      setLoading(false); 
    });

    // Clean up subscription on component unmount
    return () => unsubscribe();
  }, []);

  // Callback function to handle successful authentication
  const handleAuthSuccess = (user) => {
    setUser(user);
  };

  // Toggle the sidebar open/close state
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Show loading spinner while authentication is being determined
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="App">
      {!user ? (
        // Show authentication component if user is not authenticated
        <GetUser onAuthSuccess={handleAuthSuccess} />
      ) : (
        <>
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          <div className={`content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
            {/* Show overlay for mobile view when sidebar is open */}
            {isSidebarOpen && window.innerWidth <= 768 && <div className="overlay" onClick={toggleSidebar}></div>}
            <GetDash toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
